<template>
  <div>
    acs
  </div>
</template>

<script>
export default {
  mounted () {
    if (this.$route.query.payload) {
      this.$root.passedLogin = true
      window.axios.post('https://vp20cmrss5.execute-api.eu-west-2.amazonaws.com/Dev', { payload: this.$route.query.payload })
        .then(response => {
          let user = JSON.parse(response.data.user)
          user = (user.id) ? user : user[0]

          if (!user) {
            this.$root.passedPayload = false
            this.$root.passedLogin = false
            return this.$router.push('/')
          }

          this.$store.commit('setUser', user)
          this.$store.commit('accessToken', response.data.token)
          this.$root.passedPayload = true
          this.$router.push('/', () => {
            this.$root.finishLogin()
          })
        }).catch(error => {
          if (error) {
            this.$root.passedPayload = false
            this.$root.passedLogin = false
            return this.$router.push('/')
          }
        })
    }
  }
}
</script>
